module.exports = __webpack_public_path__ + "static/media/banner_home_brunch.40f732ad.jpg";